import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  ViewChildren,
  QueryList,
  ChangeDetectionStrategy
} from '@angular/core';
import {
  EmergencyContactAudit,
  PhoneNumberAudit,
  EmergencyContactSkeleton,
  PhoneNumberSkeleton
} from '../../+models/person-profile-audit.model';
import { PersonProfileEmergencyContactPhoneNumberAuditListComponent } from '../person-profile-emergency-contact-phone-number-audit-list/person-profile-emergency-contact-phone-number-audit-list.component';

@Component({
  selector: 'sd-portal-person-profile-emergency-contact-audit-list',
  templateUrl: './person-profile-emergency-contact-audit-list.component.html',
  styleUrls: ['./person-profile-emergency-contact-audit-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PersonProfileEmergencyContactAuditListComponent implements OnInit {
  @Input() emergencyContact: EmergencyContactSkeleton;
  @Input() loading: boolean;
  @Input() emergencyContactAudits: EmergencyContactAudit[];

  @Input() emergencyContactPhoneNumberAuditsLoading: boolean;
  @Input() emergencyContactPhoneNumberAudits: PhoneNumberAudit[];

  @Output() loadEmergencyContactAudits = new EventEmitter<number>();
  @Output() nextPage = new EventEmitter<number>();

  @Output() loadEmergencyContactPhoneNumberAudits = new EventEmitter<number>();
  @Output() nextEmergencyContactPhoneNumberAuditPage = new EventEmitter<number>();

  @ViewChildren(PersonProfileEmergencyContactPhoneNumberAuditListComponent)
  personProfileEmergencyContactPhoneNumberAuditLists: QueryList<PersonProfileEmergencyContactPhoneNumberAuditListComponent>;

  constructor() {}

  ngOnInit() {}

  loadData() {
    this.loadEmergencyContactAudits.emit(this.emergencyContact.emergencyContactId);
  }

  onNextPage() {
    this.nextPage.emit(this.emergencyContact.emergencyContactId);
  }

  emergencyContactPhoneNumberAuditOpened(emergencyContactPhoneNumber: PhoneNumberSkeleton) {
    setTimeout(() => {
      const match = this.personProfileEmergencyContactPhoneNumberAuditLists.find(
        p =>
          p.emergencyContactPhoneNumber.phoneNumberId === emergencyContactPhoneNumber.phoneNumberId
      );

      if (!match) {
        return;
      }

      match.loadData();
    });
  }
}
